// 售后状态异常
export const AUDIT_STATUS_MAP = {
  ALL: 0,
  WAIT: 1,
  PASS: 2,
  REJECT: 3,
};
export const auditStatusOption = [
  { label: '全部', value: AUDIT_STATUS_MAP.ALL, key: AUDIT_STATUS_MAP.ALL, content: '全部' },
  { label: '待审核', value: AUDIT_STATUS_MAP.WAIT, key: AUDIT_STATUS_MAP.WAIT, content: '待审核' },
  { label: '通过', value: AUDIT_STATUS_MAP.PASS, key: AUDIT_STATUS_MAP.PASS, content: '通过' },
  {
    label: '未通过',
    value: AUDIT_STATUS_MAP.REJECT,
    content: '未通过',
    key: AUDIT_STATUS_MAP.REJECT,
  },
];
export const ROLE_MAP = {
  COURIER: 0,
  SALE: 1,
  USER: 2,
  OTHER: 3,
  COMPANY: 99,
};
export const rolesOption = [
  { content: '顺丰小哥', value: ROLE_MAP.COURIER, key: ROLE_MAP.COURIER },
  { content: '丰食销售', value: ROLE_MAP.SALE, key: ROLE_MAP.SALE },
  { content: '丰食用户', value: ROLE_MAP.USER, key: ROLE_MAP.USER },
  { content: '其他', value: ROLE_MAP.OTHER, key: ROLE_MAP.OTHER },
  { content: '企业', value: ROLE_MAP.COMPANY, key: ROLE_MAP.COMPANY },
];
export const benefitFlagOption = [
  { content: '是', value: 1, key: 1 },
  { content: '否', value: 0, key: 0 },
];
export const PAY_METHORD_MAP = {
  WX: 0,
  SF: 1,
  COMPANY: 2,
  WELFARE: 3,
};
// 奖励基数
export const awardList = [
  { label: '微信支付', value: PAY_METHORD_MAP.WX, disabled: true },
  { label: '顺丰餐卡', value: PAY_METHORD_MAP.SF, disabled: false },
  { label: '企业福利金', value: PAY_METHORD_MAP.COMPANY, disabled: false },
  { label: '福利餐票', value: PAY_METHORD_MAP.WELFARE, disabled: false },
];

export const auditStatusMap = ['', '待审核', '已通过', '未通过'];

export const REWARD_TYPE = {
  RECOMMEND_NEW: 0, // 拉新
  ORDER: 1, // 下单
  CHAT_RECOMMEND_NEW: 2, // 企业微信用户拉新
  CHAT_ORDER: 3,
};

export const ACTIVITY_STATUS = {
  FORBIDDEN: 2,
  ALLOW: 1,
  ALL: 0,
};

export const ACTIVITY_STATUS_OPTIONS = [
  { label: '全部', value: ACTIVITY_STATUS.ALL },
  { label: '启用', value: ACTIVITY_STATUS.ALLOW },
  { label: '停用', value: ACTIVITY_STATUS.FORBIDDEN },
];

export const CHIEF_USE_STATUS = {
  ALLOW: 0, // 解禁
  FORBIDDEN: 1, // 封禁
};
export const statusOption = [
  { content: '封禁', value: CHIEF_USE_STATUS.FORBIDDEN, key: CHIEF_USE_STATUS.FORBIDDEN },
  { content: '解禁', value: CHIEF_USE_STATUS.ALLOW, key: CHIEF_USE_STATUS.ALLOW },
];
export const USER_TYPE_STATUS = {
  ALL: 0,
  GROUPS: 1,
};
